import {
  extractHubURL,
  fetch,
  mercureSubscribe as subscribe
} from '../../utils/dataAccess';

export function error(error) {
  return { type: 'ACCOUNT_SHOW_ERROR', error };
}

export function loading(loading) {
  return { type: 'ACCOUNT_SHOW_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'ACCOUNT_SHOW_SUCCESS', retrieved };
}

export function retrieve(id) {
  return dispatch => {
    dispatch(loading(true));

    return fetch(id)
      .then(response =>
        response
          .json()
          .then(retrieved => ({ retrieved, hubURL: extractHubURL(response) }))
      )
      .then(({ retrieved, hubURL }) => {
        //retrieved = normalize(retrieved);

        dispatch(loading(false));
        dispatch(success(retrieved));

        if (hubURL) dispatch(mercureSubscribe(hubURL, retrieved['@id']));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function patchUpdate(item, values) {
  return dispatch => {
    dispatch(loading(true));

    return fetch(item['@id'], {
      method: 'PATCH',
      headers: new Headers({ 'Content-Type': 'application/merge-patch+json' }),
      body: JSON.stringify(values)
    })
      .then(response =>
        response
          .json()
          .then(retrieved => ({ retrieved, hubURL: extractHubURL(response) }))
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        return dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'ACCOUNT_SHOW_RESET' });
    dispatch(error(null));
    dispatch(loading(false));
  };
}

export function mercureSubscribe(hubURL, topic) {
  return dispatch => {
    const eventSource = subscribe(hubURL, [topic]);
    dispatch(mercureOpen(eventSource));
    eventSource.addEventListener('message', event =>
      //dispatch(mercureMessage(normalize(JSON.parse(event.data))))
      dispatch(mercureMessage(JSON.parse(event.data)))
    );
  };
}

export function mercureOpen(eventSource) {
  return { type: 'ACCOUNT_SHOW_MERCURE_OPEN', eventSource };
}

export function mercureMessage(retrieved) {
  return dispatch => {
    if (1 === Object.keys(retrieved).length) {
      dispatch({ type: 'ACCOUNT_SHOW_MERCURE_DELETED', retrieved });
      return;
    }

    dispatch({ type: 'ACCOUNT_SHOW_MERCURE_MESSAGE', retrieved });
  };
}
